var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card-body",
    [
      _c("b-card-title", { attrs: { "title-tag": "h2" } }, [
        _vm._v("\n        " + _vm._s(_vm.linkCardTitle) + "\n    ")
      ]),
      _vm._v(" "),
      _vm.linkItems && _vm.linkItems.length > 0
        ? [
            _c(
              "b-list-group",
              {
                staticClass: "list-group-multicolor-icons",
                attrs: { flush: "" }
              },
              _vm._l(_vm.linkItems, function(linkItem, key, index) {
                return _c(
                  "b-list-group-item",
                  {
                    key: index,
                    staticClass: "bg-transparent",
                    attrs: {
                      href: _vm.getLinkHref(linkItem),
                      target: "_blank"
                    },
                    on: {
                      click: function($event) {
                        return _vm.performClick(linkItem, $event)
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fas fa-square fa-xs" }),
                    _vm._v(
                      "\n                " +
                        _vm._s(linkItem.linkText) +
                        "\n            "
                    )
                  ]
                )
              }),
              1
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-80bd72b0", { render: render, staticRenderFns: staticRenderFns })
  }
}